export const SHOW_STAFF_INVITATION_CONFIRM = 'SHOW_STAFF_INVITATION_CONFIRM';
export const CANCEL_STAFF_INVITATION_CONFIRM = 'CANCEL_STAFF_INVITATION_CONFIRM';
export const CLOSE_STAFF_INVITATION_CONFIRM = 'CLOSE_STAFF_INVITATION_CONFIRM';

export const SHOW_STAFF_INVITATION = 'SHOW_STAFF_INVITATION';
export const CANCEL_STAFF_INVITATION = 'CANCEL_STAFF_INVITATION';
export const CLOSE_STAFF_INVITATION = 'CLOSE_STAFF_INVITATION';

export const SHOW_STAFF_INVITATION_SUCCESS = 'SHOW_STAFF_INVITATION_SUCCESS';
export const CLOSE_STAFF_INVITATION_SUCCESS = 'CLOSE_STAFF_INVITATION_SUCCESS';

export const SHOW_BOOK_CREW_CONFIRM = 'SHOW_BOOK_CREW_CONFIRM';
export const CLOSE_BOOK_CREW_CONFIRM = 'CLOSE_BOOK_CREW_CONFIRM';

export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const CLOSE_SUCCESS = 'CLOSE_SUCCESS';